import { Controller } from "@hotwired/stimulus"

// Click-through for the persona hero card's picture area: tapping the left or
// right half of the face steps back and forward through THIS persona's ready
// portraits. Same interaction as the dating card's photo stepper (invisible
// half-width tap zones, stacked <img>s toggled with d-none, one dot per frame),
// deliberately reimplemented here instead of reusing
// dating_profile_panel_controller: that controller also owns the dating
// sidebar's open/close and actions menu, and mounting it on a persona card to
// borrow one private method would import all of it.
//
// Mounted on .persona-card-portrait, so it works in both places the hero renders
// (the character-card sidebar and the stacked main column) and survives the
// polling controller's in-place hero swap — Stimulus reconnects on the new node.
//
// The server decides whether stepping is possible at all: it renders the tap
// zones and the dots only when there are two or more frames and nothing is
// brewing. So there is no state here beyond "which image is visible", read off
// the DOM each time rather than cached — the hero can be replaced underneath us
// at any moment.
export default class extends Controller {
    connect() {
        this._onClick = (e) => {
            let zone = e.target.closest("[data-persona-photo-step]")
            if (!zone || !this.element.contains(zone)) return
            e.preventDefault()
            this._step(parseInt(zone.dataset.personaPhotoStep, 10))
        }
        this.element.addEventListener("click", this._onClick)
    }

    disconnect() {
        this.element.removeEventListener("click", this._onClick)
    }

    _step(delta) {
        let imgs = Array.from(this.element.querySelectorAll(".persona-hero-photo"))
        if (imgs.length < 2 || !Number.isFinite(delta)) return
        let current = imgs.findIndex((img) => !img.classList.contains("d-none"))
        if (current < 0) return
        // Clamped, not wrapped: the frames are in a meaningful order (the face on
        // the card, then newest portrait first), and wrapping from the oldest back
        // to the current face reads as a glitch rather than a loop.
        let next = Math.min(Math.max(current + delta, 0), imgs.length - 1)
        if (next === current) return
        imgs.forEach((img, i) => {
            img.classList.toggle("d-none", i !== next)
            // The visible frame is the one that describes the card; the rest are
            // decoration until stepped onto.
            if (i === next) img.removeAttribute("aria-hidden")
            else img.setAttribute("aria-hidden", "true")
        })
        this.element.querySelectorAll(".persona-photo-dot").forEach((dot, i) => dot.classList.toggle("is-active", i === next))
    }
}
